/**
 * @file Re-exports the powered-by logo component.
 */
import PoweredByLogo from "./PoweredByLogo";

export default PoweredByLogo;
